import React, {useEffect, useState } from "react";
import { FormCheckbox ,Row , Col } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";

const CheckboxYears = (props) => {
  const { token } = useToken();
  const { getValue ,indicatorsDatasetSettingId } = props;
  const [ yearList , setYearList ] = useState(null);
  const [ yearGroupList , setYearGroupList ] = useState(null);
  const [selectYear , setSelectYear ] = useState([]);

  const filterYear = (data) => {
    return data.filter(item => {
      if(yearGroupList.includes(item.yearNo)){
        return item;
      }
    });
  };

  const getYeargroup = () =>{
    const axios = require("axios").default;
    var data = JSON.stringify({
      "indicatorsDatasetSettingId": indicatorsDatasetSettingId || null
    });
 
    var config = {
      method: 'post',
      url: `${baseUrl}/v1/setting-table/yeargroupheadshowtable`,
      headers: { 
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios(config).then(function (response) {
      const result = Object.keys(response.data).map(key => response.data[key].yearNo);
      setYearGroupList(result);
    })
    .catch(function (error) {
      console.log("setting-table/listyear",error);
    });
  }


  const getYearList = () => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      "show": 100,
      "page": 1,
      "orderBy": "yearId",
      "orderType": "DESC"
    });
 
    var config = {
      method: 'post',
      url: `${baseUrl}/v1/setting-table/listyear`,
      headers: { 
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios(config).then(function (response) {
      setYearList(response.data.data);
    })
    .catch(function (error) {
      console.log("setting-table/listyear",error);
    });
  };

  const handleChange = (e,year) => {
    const index = selectYear.indexOf(year);
    if (index === -1) { 
      setSelectYear([...selectYear, year]);
    }else{
      setSelectYear(selectYear.filter((e)=>(e !== year)))
    }
  }

  useEffect(() => {
    getYeargroup();
    getYearList();
  }, []);

  useEffect(() => {
    getValue(selectYear)
  }, [selectYear]);

  return (
    <Row>
      { yearGroupList != null && yearGroupList.length > 0 && yearList != null && yearList.length > 0 &&
      filterYear(yearList).map((item, key) => (
      <Col md="3">
        <FormCheckbox
          key={item.yearId}
          inline
          checked={selectYear.indexOf(item.yearNo) !== -1}
          onChange={(e) => handleChange(e,item.yearNo)}
        >
          {item.yearNo}
        </FormCheckbox>
      </Col>
      ))}
    </Row>
  )
};
export default CheckboxYears;
